import { createRoot } from 'react-dom/client'
import { loadJSONFromDOMNode } from '@utils/dom_node_data_loader.ts'
import NotificationsContainer from '@components/notifications/notifications_container.jsx'

window.Timetoast.notifications = {
  index: {
    init: function (options, reactTarget) {
      const {
        bulkDeleteNotificationsPath,
        bulkReadNotificationsPath,
        bulkUnreadNotificationsPath,
        notificationsDOMId,
      } = options
      const notifications = loadJSONFromDOMNode(notificationsDOMId)
      const root = createRoot(reactTarget)
      root.render(
        <NotificationsContainer
          notifications={notifications}
          bulkDeleteNotificationsPath={bulkDeleteNotificationsPath}
          bulkReadNotificationsPath={bulkReadNotificationsPath}
          bulkUnreadNotificationsPath={bulkUnreadNotificationsPath}
        />
      )
    },
  },
}
